import { SVGProps } from 'react';

export const IconMinus = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 20 20' fill='none'>
      <path d='M6 10L14 10' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};
